<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-row>
          <b-col cols="12" class="mb-3">
            <b-button variant="primary" @click="$router.go(-1)" class="pull-left back-btn">Terug</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-alert :show="feedback.show" dismissible :variant="feedback.variant" @dismissed="feedback.show=0" @dismiss-count-down="countDownChanged">
              {{feedback.text}}
              <ul v-if="errors" class="mt-3">
                <li v-for="error in errors">{{error.toString()}}</li>
              </ul>
            </b-alert>
            <b-card>
              <template #header>
                <span class="pull-left mt-2"><strong>Mededeling "{{item.title}}"</strong></span>
                <b-button @click="editable = true" class="pull-right" variant="primary" v-can="'mededelingen aanpassen'" v-if="!editable">Bewerken</b-button>
              </template>
              <b-form @submit.prevent="saveItem">
                <b-row>
                  <b-col cols="12" sm="10" md="6">
                    <b-row>
                    <b-col cols="12" md="8">
                      <h5>Inhoud</h5>
                      <hr>
                    </b-col>
                      <b-col cols="12" md="6">
                        <b-form-group label="Titel">
                          <b-form-input type="text" required v-model="item.title" :disabled="!editable" />
                        </b-form-group>
                      </b-col>
                  </b-row>
                      <b-row>
                      <b-col cols="12" md="10">
                        <b-form-group label="Inhoud">
                          <b-form-textarea type="text" rows="6" required v-model="item.content" :disabled="!editable" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" sm="10" md="6">
                    <b-row>
                    <b-col cols="12" md="8">
                      <h5>Instellingen</h5>
                      <hr>
                    </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6">
                        <b-form-group label="Actief">
                          <b-form-checkbox v-model="item.active" :disabled="!editable" switch class="mt-2">
                            {{item.active ? 'Is zichtbaar in de Portal' : 'Is niet zichtbaar in de Portal'}}
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      <b-col cols="12" md="4">
                        <b-form-group label="Vanaf">
                          <b-form-input type="date" required v-model="item.date_start" :disabled="!editable" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" md="4">
                        <b-form-group label="Tot">
                          <b-form-input type="date" v-model="item.date_end" :disabled="!editable" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row v-if="editable">
                  <b-col cols="12">
                    <hr class="mb-4">
                    <b-button type="submit" variant="primary" class="mr-3" :disabled="saveButtonDisabled">Wijzigingen opslaan</b-button>
                    <b-button @click.prevent="cancelEdit" >Annuleren</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import { updateData, getData } from '../../api';

export default {
  name: 'announcement',
  props: ['id'],
  data() {
    return {
      saveButtonDisabled: false,
      feedback: {
        show: false,
        text: '',
        variant: null,
        dismissCountDown: 4
      },
      editable: false,
      item: {},
      errors: null,
    }
  },
  methods: {
    async getItem() {
      await getData('announcements/' + this.$route.params.id).then(({ data }) => this.item = data.data);
    },
    async saveItem() {
      this.errors = null;
      this.saveButtonDisabled = true;
      const request = await updateData(`announcements/${this.$route.params.id}`, this.item);
      if (request.status === 200) {
        this.feedback.show = true;
        this.feedback.text = 'Mededeling succesvol geupdate';
        this.feedback.variant = 'success';
        this.editable = false;
        this.saveButtonDisabled = false;
        this.getItem();
      } else {
        this.errors = request.data.errors;
        this.feedback.show = true;
        this.feedback.text = 'Er ging iets mis...';
        this.feedback.variant = 'danger';
        this.editable = true;
        this.saveButtonDisabled = false;
        this.getItem();
      }
    },
    cancelEdit() {
      this.editable = false;
      this.getItem();
    },
    countDownChanged(dismissCountDown) {
      this.feedback.dismissCountDown = dismissCountDown
    },
  },
  beforeMount() {
    this.getItem();
  },
}

</script>
